import Swal from "sweetalert2";
import { ICartaoDetalhe, IContaParticipante, IRelatorio } from "../interfaces/IRelatorio";
import api from "./Api";

class CartaoNovaService {
    async buscarCartoesPorEsteira(esteiraID: number, tipo: string): Promise<IRelatorio[]> {
        const { data: result } = await api.get<IRelatorio[]>(`v2/Cartao/Esteira/${esteiraID}/${tipo}`);

        return result;
    }

    async atualizarStatus(id: number, status: string): Promise<void> {
        await api.put(`v2/Cartao/Status/${id}/${status}`, null);
    }

    async buscarCartaoPorId(id: number): Promise<ICartaoDetalhe> {
        const { data } = await api.get<ICartaoDetalhe>(`Cartao/detalhe/${id}`);
        return data;
    }

    async buscarContasParticipante(esteiraID: number, cnpj: string): Promise<IContaParticipante[]> {
        const { data } = await api.get<IContaParticipante[]>(`Cartao/${esteiraID}/${cnpj}/contas-participante`);
        return data;
    }

    async buscarCartoesPorEmpresa(empresaID: number): Promise<IRelatorio[]> {
        try {
            const { data: result } = await api.get<IRelatorio[]>(`Cartao/empresa/${empresaID}`, {
                baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
            });

            return result;
        } catch (error: any) {
            Swal.fire({
                text: error.message,
                timer: 4000,
                icon: 'error',
                showConfirmButton: false
            });

            return [];
        }
    }
}


export default new CartaoNovaService();